@for (lessonType of rows(); track $index) {
	<div class="completion-info-content">
		@if (lessonType.totalLessons === 0) {
			@if (lessonType.expectedLessons > 0) {
				<div>{{ lessonType.lessonTypeName }} Lessons</div>
				<div class="completion-info-lesson">
					<md-tag type="tertiary">{{ lessonType.completedLessons }}/{{ lessonType.expectedLessons }}</md-tag>
					<md-progress-bar [height]="16" [progress]="0"></md-progress-bar>
				</div>
			}
		} @else {
			<div>{{ lessonType.lessonTypeName }} Lessons</div>
			<div class="completion-info-lesson">
				<md-tag type="tertiary">{{ lessonType.completedLessons }}/{{ lessonType.totalLessons }}</md-tag>
				<md-progress-bar [height]="16" [progress]="(lessonType.completedLessons / lessonType.totalLessons) * 100"></md-progress-bar>
			</div>
		}
	</div>
}
